// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../admin/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.column-title {\n\tmin-height: 36px;\n\tdisplay: flex;\n\talign-items: flex-start;\n\tmargin-bottom: 1em;\n}\n", ""]);
// Exports
module.exports = exports;
